import NextLink, { type LinkProps } from "next/link";
import React from "react";
import { cn } from "../../helpers/classNames";
import styles from "./styles.module.scss";

type Props = {
    children: React.ReactNode;
    fullWidth?: boolean;
    linkType?: "anchor" | "nextLink";
    type:
        | "snowPrimary"
        | "snowSecondary"
        | "weatherPrimary"
        | "weatherSecondary"
        | "weatherTertiary";
} & LinkProps &
    React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const StyledLink: React.FC<Props> = ({
    children,
    type,
    fullWidth,
    linkType = "nextLink",
    ...props
}) => {
    if (type === "weatherPrimary") {
        if (linkType === "anchor") {
            return (
                <a
                    {...props}
                    className={cn(
                        props.className,
                        styles.weatherButton,
                        styles.weatherPrimary,
                        fullWidth && styles.fullWidth
                    )}
                >
                    {children}
                </a>
            );
        }
        return (
            <NextLink
                {...props}
                className={cn(
                    props.className,
                    styles.weatherButton,
                    styles.weatherPrimary,
                    fullWidth && styles.fullWidth
                )}
            >
                {children}
            </NextLink>
        );
    } else if (type === "weatherSecondary") {
        if (linkType === "anchor") {
            return (
                <a
                    {...props}
                    className={cn(
                        props.className,
                        styles.weatherButton,
                        styles.weatherSecondary,
                        fullWidth && styles.fullWidth
                    )}
                >
                    {children}
                </a>
            );
        }
        return (
            <NextLink
                {...props}
                className={cn(
                    props.className,
                    styles.weatherButton,
                    styles.weatherSecondary,
                    fullWidth && styles.fullWidth
                )}
            >
                {children}
            </NextLink>
        );
    } else if (type === "weatherTertiary") {
        if (linkType === "anchor") {
            return (
                <a
                    {...props}
                    className={cn(
                        props.className,
                        styles.weatherButton,
                        styles.weatherTertiary,
                        fullWidth && styles.fullWidth
                    )}
                >
                    {children}
                </a>
            );
        }

        return (
            <NextLink
                {...props}
                className={cn(
                    props.className,
                    styles.weatherButton,
                    styles.weatherTertiary,
                    fullWidth && styles.fullWidth
                )}
            >
                {children}
            </NextLink>
        );
    } else if (type === "snowPrimary") {
        if (linkType === "anchor") {
            return (
                <a
                    {...props}
                    className={cn(
                        props.className,
                        styles.snowButton,
                        styles.snowPrimary,
                        fullWidth && styles.fullWidth
                    )}
                >
                    {children}
                </a>
            );
        }
        return (
            <NextLink
                {...props}
                className={cn(
                    props.className,
                    styles.snowButton,
                    styles.snowPrimary,
                    fullWidth && styles.fullWidth
                )}
            >
                {children}
            </NextLink>
        );
    } else {
        if (linkType === "anchor") {
            return (
                <a
                    {...props}
                    className={cn(
                        props.className,
                        styles.snowButton,
                        styles.snowSecondary,
                        fullWidth && styles.fullWidth
                    )}
                >
                    {children}
                </a>
            );
        }
        return (
            <NextLink
                {...props}
                className={cn(
                    props.className,
                    styles.snowButton,
                    styles.snowSecondary,
                    fullWidth && styles.fullWidth
                )}
            >
                {children}
            </NextLink>
        );
    }
};
